module.exports = __webpack_public_path__ + "img/Frame 1138.455fc189.svg";